export class CountryGroup {
  countryGroupID: number;
  name: string;
  description: string;
  dountryIDs: Array<number>
}
